<template>
  <div class="img col-sm-12">
    <img src="../assets/IMG/Fondo_peq.png" alt="Fondo" />

    <div class="tx-text text-center">
      <h1 class="headline">
        MY WORD
      </h1>
    </div>
  </div>
</template>

<script>
export default { name: "Everybody" };
</script>

<style scoped>
.img {
  position: relative;
  width: 100%;
  display: block;
  background-color: #efefe4;
  margin: 0;
  padding: 0;
}

.img::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 50% 48%,
    rgba(0, 0, 0, 0.14) 0%,
    rgba(0, 0, 0, 0.08) 58%,
    rgba(0, 0, 0, 0.02) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.img img {
  width: 100%;
  height: auto;
  display: block;
}

.tx-text {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(1260px, 96%);
  text-align: center;
}

.headline {
  position: relative;
  display: inline-block;
  margin: 0;
  line-height: 0.88;
  letter-spacing: 0.07em;
  color: #f4f1df;
  text-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
  font-family: "Barlow", sans-serif;
  font-weight: 800;
  font-style: italic;
  font-size: clamp(64px, 12vw, 230px);
  transform: skewX(-4deg);
  animation: heroIn 650ms ease both;
}

.headline::after {
  content: "";
  position: absolute;
  top: -9%;
  right: clamp(-122px, -8vw, -40px);
  width: clamp(68px, 5.4vw, 114px);
  height: clamp(68px, 5.4vw, 114px);
  background: url("../assets/IMG/huella.png") center / contain no-repeat;
}

@media (hover: hover) {
  .headline:hover {
    transform: skewX(-4deg) translateY(-2px);
    transition: transform 180ms ease;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .tx-text {
    top: 51%;
    width: min(980px, 94%);
  }

  .headline {
    font-size: clamp(62px, 11vw, 150px);
    letter-spacing: 0.06em;
  }

  .headline::after {
    top: -6%;
    right: clamp(-82px, -6.4vw, -30px);
    width: clamp(56px, 4.9vw, 88px);
    height: clamp(56px, 4.9vw, 88px);
  }
}

@media (max-width: 767px) {
  .img {
    height: 280px;
  }

  .img img {
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .tx-text {
    top: 52%;
    width: 96%;
  }

  .headline {
    line-height: 0.9;
    font-size: clamp(58px, 16.5vw, 118px);
    letter-spacing: 0.05em;
  }

  .headline::after {
    top: -2%;
    right: clamp(-52px, -8vw, -20px);
    width: clamp(44px, 9.8vw, 70px);
    height: clamp(44px, 9.8vw, 70px);
  }
}

@media (max-width: 420px) {
  .img {
    height: 255px;
  }

  .tx-text { top: 53%; }

  .headline { font-size: clamp(50px, 15.5vw, 90px); }
}

@keyframes heroIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
    filter: blur(1px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .headline { animation: none; }
}
</style>
